exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workflows-output-schemes-table {\n  margin-bottom: 16px;\n}\n.workflows-output-schemes-table .cell-limited-max-width {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.workflows-output-schemes-table .cell-limited-max-width.name {\n  max-width: 250px;\n}\n", ""]);

// exports
